// extracted by mini-css-extract-plugin
module.exports = {"main_page":"Investments_main_page__3PZok","main_header":"Investments_main_header__2Yvyg","content":"Investments_content__JcxhU","tabs":"Investments_tabs__389Nc"};